import type { NextPage } from 'next';
import { useMemo } from 'react';

import { useIsMobile } from '@sravni/react-utils';

import type { Application } from '@src/@types/app';
import SeoComponents from '@src/components/SeoComponents';
import { PageContext } from '@src/config';
import { getPageListData } from '@src/config/getPageListData';
import type { IPageContextConfig } from '@src/config/PageContext';
import { MODES } from '@src/constants/filters';
import { ListKeys } from '@src/constants/microcredits';
import ProductList from '@src/containers/list/ProductList';
import { useBestProducts } from '@src/hooks/useBestProducts';
import { useListPage } from '@src/hooks/useListPage';
import { useLoadRestOffers } from '@src/hooks/useLoadRestOffers';
import { Layout } from 'app/Layout';

import styles from './CalculatorPage.module.scss';
import { CalculatorPageHeader } from './CalculatorPageHeader';

const pageConfig: IPageContextConfig = {
  listKey: ListKeys.CALCULATOR,
  source: 'search',
  cardTermIsVisible: true,
  withCardProductLink: true,
  sortPanelVisible: true,
};

export const CalculatorPage: NextPage = () => {
  const isMobile = useIsMobile();
  const { filter, seo, pathname, hasUtmLabel } = useListPage(ListKeys.CALCULATOR);
  const config = useMemo(() => ({ ...pageConfig, withMonetizationCardLogoClick: isMobile }), [isMobile]);

  const hasSeoBlocks = !hasUtmLabel && Boolean(seo);

  useLoadRestOffers(ListKeys.CALCULATOR);
  useBestProducts();

  return (
    <Layout>
      <PageContext.Provider value={config}>
        <CalculatorPageHeader filters={filter.filters} />
        <ProductList className={styles.product_list} filter={filter} pathname={pathname} />
        {hasSeoBlocks && <SeoComponents seo={seo} breadcrumbs={seo.breadcrumbs} prefooter={seo.prefooter} />}
      </PageContext.Provider>
    </Layout>
  );
};

CalculatorPage.getInitialProps = (ctx: Application.ReduxNextPageContext) =>
  getPageListData(ctx, { key: ListKeys.CALCULATOR, defaultFiltersMode: MODES.CALCULATOR });
